import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import FieldTitle from './FieldTitle';
import ImageManager from '../../misc/ImageManager';

import Tooltip from '../../misc/Tooltip';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  /*
   * Only use height when you don't need height 
   * measurements of the table field.
   */
  ${(props) => {
    return props.measure ? '' : 'height: 100%;';
  }}

`;

const StyledTooltipWrapper = styled.div`
  position: absolute;
  right:0;
  top:0;
  z-index:99
`;

const StyledImageManagerWrapper = styled.div`
  height: 100%;
  overflow: hidden;
  border: 1px solid transparent;

`;

const ImageField = ({

  fieldId,
  fieldIdentifier,
  fieldPositionId,

  title,
  value,
  multi,

  fontColor,
  padding,
  borderRadius,
  borderWidth,
  borderColor,
  backgroundColor,
  primaryColor,
  secondaryColor,
  dangerColor,

  //Title styles
  titleDisplay,
  titleFontSize,
  titleFontColor,
  titleTextAlign,
  titleFontStyle,
  titleFontWeight,
  titleTextTransform,
  titleTextDecoration,

  disabled,
  isMobileView,

  primaryMaxWidth,
  primaryMaxHeight,
  primaryDisplayOnly,

  onUpload,
  onChange,
  onFocus,

  tipTitle,
  tipDescription,
  tipVisible,

  //Used for calculating width and height of element
  measure,
  onMeasureCompleted

}) => {

  const isDisabled = primaryDisplayOnly || disabled;
  const values = Array.isArray(value) ? value : [value];

  const [wrapperRef, setWrapperRef] = useState(null);
  const [loadedImages, setLoadedImages] = useState(false);

  useEffect(() => {
    if (onMeasureCompleted && wrapperRef && loadedImages) {
      onMeasureCompleted(fieldId, fieldIdentifier, fieldPositionId, wrapperRef.getBoundingClientRect());
    }
  }, [wrapperRef, loadedImages]);

  const handleDrop = (files) => {
    if (onUpload) onUpload(fieldId, fieldIdentifier, fieldPositionId, files);
  };

  const handleDelete = (i) => {

    const nextImageValues = [...values];
    nextImageValues.splice(i, 1);

    onChange(fieldId, fieldIdentifier, fieldPositionId, nextImageValues);

  };

  const handleFocus = () => {
    if (onFocus) onFocus(fieldId, fieldIdentifier, fieldPositionId, {});
  };

  const handleLoadCompleted = () => {
    setLoadedImages(true);
  };

  return (
    <StyledWrapper
      measure={measure}
      ref={(e) => {
        if (e && !wrapperRef) setWrapperRef(e);
      }}
    >
      <FieldTitle
        {...{
          title,
          titleDisplay,
          titleFontSize,
          titleFontColor,
          titleTextAlign,
          titleFontStyle,
          titleFontWeight,
          titleTextTransform,
          titleTextDecoration,
        }}
      />
      {disabled ? null : (
        <StyledTooltipWrapper>
          <Tooltip
            fieldId={fieldId}
            title={tipTitle}
            description={tipDescription}
            tipVisible={tipVisible}
          />
        </StyledTooltipWrapper>
      )}
      <StyledImageManagerWrapper {...{ borderRadius, disabled: isDisabled }}>
        <ImageManager
          {...{
            value,
            isMobileView,
            multiple: multi,
            disabled: isDisabled,
            maxWidth: primaryMaxWidth ? `${primaryMaxWidth}px` : 0,
            maxHeight: primaryMaxHeight ? `${primaryMaxWidth}px` : 0,
            onLoadCompleted: handleLoadCompleted,
            onDelete: handleDelete,
            onDrop: handleDrop,
            onFocus: handleFocus,
            fontColor,
            padding,
            borderRadius,
            borderWidth,
            borderColor,
            backgroundColor,
            primaryColor,
            secondaryColor,
            dangerColor
          }}
        />
      </StyledImageManagerWrapper>
    </StyledWrapper>
  );

};

export default React.memo(ImageField);
